export const env = {
  stage: import.meta.env.VITE_STAGE ?? "development",
  isDev: (import.meta.env.VITE_STAGE ?? "development") === "development",
  aws: {
    region: import.meta.env.VITE_AWS_REGION ?? "eu-west-1",
    cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
    },
    websocketUrl: import.meta.env.VITE_WEBSOCKET_URL ?? "",
    apiUrl: import.meta.env.VITE_API_URL ?? "",
  },
  mapbox: {
    accessToken: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN ?? "",
  },
  openai: {
    apiKey: import.meta.env.VITE_OPENAI_API_KEY ?? "",
  },
  admin: {
    // Comma-separated list of admin emails, e.g. "alice@x.com,bob@x.com".
    emails: (import.meta.env.VITE_ADMIN_EMAIL ?? "")
      .split(",")
      .map((e: string) => e.trim().toLowerCase())
      .filter(Boolean),
  },
} as const;
